import {createContext, useContext} from "react";
import type {ProductCatalogue} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/productCataloguesWorkspaceCapability/domain/ProductCatalogue";

type ProductsContextData = Array<ProductCatalogue>;

export const ProductCatalogueContext = createContext<ProductsContextData | undefined>(undefined);

export function useProductCatalogue(): ProductsContextData {
    const productsContextData = useContext(ProductCatalogueContext);
    if (productsContextData === undefined) {
       throw new Error("ProductCatalogueContext.Provider not found");
    }

    return productsContextData;
}
